// extracted by mini-css-extract-plugin
module.exports = {"SignUp":"SignUp_SignUp__3FiKZ","LoginForm":"SignUp_LoginForm__1Xv5s","ValidationError":"SignUp_ValidationError__2ZfyI"};